import { createFileRoute } from '@tanstack/react-router';
import { SalesOrderDetail } from '../../../../features/sales-invoicing/SalesOrderDetail';

/** Sales order detail — editable while DRAFT (+ Open), Complete/Cancel while
 * OPEN, Cancel while DRAFT, and a linked-dispatches list once past DRAFT. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/sales-orders/$salesOrderId')({
  component: SalesOrderDetailPage,
});

function SalesOrderDetailPage() {
  const { salesOrderId } = Route.useParams();
  return <SalesOrderDetail salesOrderId={salesOrderId} />;
}
